/**
 * In-call audio-route picks closer together than this are one activation. A
 * Telecom route switch takes ~0.5 s to land; a second tap in that window reads
 * the new route and flips it straight back.
 */
export const ROUTE_TAP_GUARD_MS = 600

/** How long a pick shows as selected while the OS route catches up. */
export const ROUTE_PICK_SETTLE_MS = 1_500

export function acceptsRouteTap(lastTapAtMs: number | null, nowMs: number): boolean {
  return lastTapAtMs === null || nowMs - lastTapAtMs >= ROUTE_TAP_GUARD_MS
}

/** The route the control shows: the user's pick until the OS route matches or settles. */
export function displayedRouteKind<K extends string>(
  pending: { kind: K; atMs: number } | null,
  liveKind: K,
  nowMs: number,
): K {
  if (!pending || pending.kind === liveKind) return liveKind
  return nowMs - pending.atMs < ROUTE_PICK_SETTLE_MS ? pending.kind : liveKind
}
